/**
 * Database table names used in the database schema related to the manuals feature.
 *
 * @readonly
 * @enum {string}
 */
export const MANUAL_TABLES = {
  MANUALS: 'manuals',
  MANUALS_READ: 'manuals_read',
  MANUALS_GROUPS: 'manuals_groups',
  MANUALS_LANGUAGE: 'manuals_language',
  MANUALS_LANGUAGE_ATTACHMENTS: 'manuals_language_attachments',
};

/**
 * Action identifiers for manual-related user interactions.
 *
 * @readonly
 * @enum {string}
 */
export const MANUALS_ACTIONS = {
  CANCEL: 'cancelReadManual',
  CONFIRM_READ: 'confirmReadManual',
};

/**
 * Defines the colour codes used to visually represent different manual statuses.
 *
 * @enum {string}
 */
export const STATUS_COLORS = {
  overDue: '#E57373',
  notDue: '#FFB74D',
  cancelled: '#BDBDBD',
  manualRead: '#70CA44',
};

/**
 * Colour mapping for Manuals active and inactive statuses using a specific naming convention.
 *
 * @enum {string}
 */
export const ACTIVE_STATUS_COLORS = {
  '1_active': '#70CA44',
  '2_inactive': '#E57373',
};

/**
 * User groups related to Manuals with their respective identifiers.
 *
 * @enum {string}
 */
export const MANUALS_GROUPS = {
  ADMIN: 'manualsgroup',
  VIEWER: 'manualsviewer',
};
